import { Component, OnInit } from '@angular/core';
import { PageService } from 'src/app/services/page-service';
import { Pages } from 'src/app/types/pages';
import { PageBase } from '../page-base';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent extends PageBase {
  constructor(pageService: PageService) {
    super(Pages.Login, pageService);
  }
};
